/* import __COLOCATED_TEMPLATE__ from './schedule-delete-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();